import { ca } from '@cian/analytics';

import { TOfferType } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export const trackViewBookingRequestButtonClick = (
  offerId: number,
  offerType: TOfferType,
  tripId: number | undefined,
) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentRequest',
    action: 'Click',
    label: 'SeeRequest',
    page: { pageType: 'Card', siteType: 'desktop', extra: { trip_id: tripId } },
    products: [{ id: offerId, offerType }],
  });
};
